<template>
    <div class="modal open_modal" data-modal="modal">
      <div class="modal_overlay" data-modal-close="modal"></div>
      <div class="modal_wrap">
        <div class="modal_header">
          <div class="d_flex_btwn">
            <h3>Add Users</h3>
            <span>
                <span data-modal-close="modal" class="close_icon close_icon_md" @click.prevent="closeModal"></span>
            </span>
          </div>
        </div>
        <div class="modal_inner">
          <div class="modal_content modal_600p height_100p">
            <div class="row m_0 p_0">
              <div class="col_12">
                <div :class="['form_row', {'has_error': errorFor('selected_users')}]">
                    <Multiselect
                      v-model="form.selected_users"
                      :options="newUsers"
                      :multiple="true"
                      :close-on-select="true"
                      placeholder="Select users"
                      label="name"
                      track-by="name"
                    />
                    <v-errors :errors="errorFor('selected_users')"></v-errors>
                </div>
                <div class="form_row">
                  <div class="form_inline ">
                    <button class="btn btn_primary" @click="addUserToGroup">Add to group</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    name: 'add-user-modal',
    components: {Multiselect},
    data(){
        return{
            form:{
              selected_users: []
            },
            newUsers: []
        }
    },
    props: {
        showSendMailModal: {
          type: Boolean,
          default: false,
        },
        groupId: {
          type: String,
          required: true,
        },
    }, 
    created() {
      this.axios.get('/new-group-users').then((response) => {
        this.newUsers = response.data.data
      });
    },
    computed: {
        
    },
    methods:{
      addUserToGroup(){
        this.allErrors = null;
        this.lyLoading = true;
        this.form.group_id = this.groupId
        this.axios.post('/add-user-to-group', this.form)
        .then(() => {
            this.form.selected_users = [];
            this.showSuccessMsg("User Assigned Successfully!");
            this.closeModal()
        })
        .catch((err) => {
            this.allErrors = err.response.data.errors
        })
        .finally(() => {
            this.lyLoading = false;
        })
      },
      closeModal(){
        this.$emit('closeModal');
      },
    }
}
</script>

<style scoped>
.color_blue {
    color: #3c74e7!important;
}
.multiselect{
  height: 50px;
}
.height_100p{
  height: 200px;
}
</style>